/**
 * Settings alias for email templates — §11-A.
 * "Keep Settings route as an alias that points here."
 * The canonical URL is /emails?etab=templates; this route just redirects there.
 */
import { Navigate } from 'react-router-dom';

export function EmailTemplatesSettingsPage() {
  return <Navigate to="/emails?etab=templates" replace />;
}
